/* SPINTZ Engagement: only enhances the certificate link. No tracking or storage. */
(() => {
  'use strict';
  if (!window.customElements || customElements.get('spintz-engagement')) return;

  class SpintzEngagement extends HTMLElement {
    connectedCallback() {
      if (this._controller) return;
      this._controller = new AbortController();
      const options = { signal: this._controller.signal };
      this._dialog = this.querySelector('.seng__dialog');
      this._opener = this.querySelector('[data-seng-open]');
      if (!this._dialog || !this._opener || typeof this._dialog.showModal !== 'function') return;
      // Only advertise a dialog when it is supported; href remains a no-JS fallback.
      this._opener.setAttribute('aria-haspopup', 'dialog');
      this._opener.addEventListener('click', (event) => {
        if (event.defaultPrevented || event.button !== 0 || event.metaKey || event.ctrlKey || event.shiftKey || event.altKey) return;
        try {
          this._dialog.showModal();
        } catch (_) {
          return; // Preserve navigation to the original document when showModal fails.
        }
        event.preventDefault();
        const image = this._dialog.querySelector('[data-seng-src]');
        if (image && !image.getAttribute('src')) image.src = image.dataset.sengSrc;
      }, options);
      this._dialog.addEventListener('close', () => {
        if (this._opener && this._opener.isConnected) this._opener.focus({ preventScroll: true });
      }, options);
      this._dialog.addEventListener('click', (event) => {
        if (event.target !== this._dialog) return;
        const rect = this._dialog.getBoundingClientRect();
        if (event.clientX < rect.left || event.clientX > rect.right || event.clientY < rect.top || event.clientY > rect.bottom) {
          this._dialog.close();
        }
      }, options);
      const image = this._dialog.querySelector('[data-seng-src]');
      if (image) image.addEventListener('error', () => {
        image.hidden = true;
        const error = this._dialog.querySelector('.seng__document-error');
        if (error) error.hidden = false;
      }, options);
    }
    disconnectedCallback() {
      if (this._dialog && this._dialog.open) this._dialog.close();
      if (this._controller) this._controller.abort();
      this._controller = null;
    }
  }
  customElements.define('spintz-engagement', SpintzEngagement);
})();
